const LANGUAGE_API_PATH = '/asababelfish/ext/pub';
export const LANGUAGE_DATA_API = `${LANGUAGE_API_PATH}/res/messages.properties`;
export const GET_ALL_LANGUAGES_API = `${LANGUAGE_API_PATH}/api/info`;
